export const mcpClients = [
  { value: 'claude-ai', label: 'Claude.ai (web)' },
  { value: 'claude-desktop', label: 'Claude Desktop' },
  { value: 'chatgpt', label: 'ChatGPT 5' },
  { value: 'openai-codex', label: 'OpenAI Codex' },
  { value: 'vscode', label: 'VS Code' },
  { value: 'cursor', label: 'Cursor' },
  { value: 'cline', label: 'Cline' },
  { value: 'other', label: 'Other' },
];

export const handleOpenClient = (selectedClient: string | undefined) => {
  switch (selectedClient) {
    case 'claude-ai':
      window.open('https://claude.ai', '_blank');
      break;
    case 'claude-desktop':
      window.location.href = 'claude://';
      break;
    case 'chatgpt':
      window.open('https://chat.openai.com', '_blank');
      break;
    case 'openai-codex':
      window.open('https://chatgpt.com/codex', '_blank');
      break;
    case 'vscode':
      window.open(`vscode://`, '_blank');
      break;
    case 'cursor':
      window.open('cursor://', '_blank');
      break;
    case 'cline':
      window.open('https://cline.ai', '_blank');
      break;
    case 'mistral':
      window.open('https://mistral.ai', '_blank');
      break;
    default:
      window.open('https://docs.cirra.ai/mcp-server/connecting-mcp', '_blank');
  }
};

export const getSetupInstructionsUrl = (selectedClient: string | undefined) => {
  switch (selectedClient) {
    case 'claude-ai':
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp#claude-ai';
    case 'claude-desktop':
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp#claude-desktop';
    case 'chatgpt':
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp#chatgpt';
    case 'openai-codex':
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp#openai-codex';
    case 'vscode':
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp#vscode';
    case 'cursor':
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp#cursor';
    case 'cline':
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp#cline';
    default:
      return 'https://docs.cirra.ai/mcp-server/connecting-mcp';
  }
};

export const getClientName = (selectedClient: string | undefined) => {
  const client = mcpClients.find((c) => c.value === selectedClient);
  return client?.label || 'your selected client';
};
